import React, { useRef, useState } from "react";

import { FormControl, ListItemText, MenuItem, Select } from "@material-ui/core";

import { ReactComponent as downArrowIcon } from "../../assets/svg/DownArrow.svg";

import { anchorOriginDefault } from "./SearchHeaderCustomStyles";
import { SELECT_NONE } from "../../../config/constants";
import { isArrayValid, isEmptyOrNull } from "../../../utils/DataUtils";

interface SearchHeaderCustomSelectBoxInterface {
  items: any;
  value: any;
  handleChange: any;
  menuPaperProps?: any;
  classes: any;
  className?: any;
  listItemTextProps?: any;
}

export interface SelectItemProps {
  name?: string;
  value: any;
}

const SearchHeaderCustomSelectBox = (props: SearchHeaderCustomSelectBoxInterface) => {
  const { items, value, handleChange, menuPaperProps, classes, className, listItemTextProps } = props;

  const anchorEl = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const handleOnChange = (event: any) => {
    if (!isEmptyOrNull(event?.target)) {
      let selected = event.target.value;
      if (isArrayValid(selected)) {
        const filteredValue = selected.filter((item: any) => item);
        handleChange?.(filteredValue);
      } else {
        handleChange?.(selected);
      }
    }
  };

  const getChips = (selected: any) => {
    const item: SelectItemProps | undefined = items?.find(
      (i: SelectItemProps) => i.value === selected
    );
    return item?.name ?? SELECT_NONE.name;
  };

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <Select
        displayEmpty
        className={`${className ?? ""} ${isOpen ? "open " : ""}`}
        ref={anchorEl}
        labelId={""}
        multiple={false}
        value={value}
        onOpen={() => {
          setIsOpen(true);
        }}
        onClose={() => {
          setIsOpen(false);
        }}
        onChange={handleOnChange}
        renderValue={getChips}
        IconComponent={downArrowIcon}
        MenuProps={{
          classes: {
            paper: menuPaperProps || classes.menuPropsPaper,
          },
          autoFocus: false,
          anchorEl: anchorEl.current,
          getContentAnchorEl: null,
          anchorOrigin: anchorOriginDefault,
        }}
      >
        {items?.map((item: any, index: number) => (
          <MenuItem key={`${item.value}-${index}`} value={item.value}>
            <ListItemText primary={item.name} classes={{ root: classes.listItemTextRootProps, primary: listItemTextProps ?? classes.listItemTextProps }} />
          </MenuItem>
        ))
        }
      </Select>
    </FormControl>
  );
};

export default React.memo(SearchHeaderCustomSelectBox);
